<template>
  <div class="newInviteFriends">
    <van-sticky v-if="showBar==1">
      <van-nav-bar
        :border="false"
        :safe-area-inset-top="true"
        title="分享赚邀工币"
        left-arrow
        @click-left="onClickLeft"
      />
    </van-sticky>
    <div class="title-div">
      <span>
        用户{{cryptoPhone}}邀请注册
      </span>
      <span>
        {{totalRows}}人
      </span>
    </div>
    <div class="huodong-div">

      <div class="hist-list">
        <div class="hist-div">
          <div class="hist-content">

            <div class="list-content" @scroll="handleScroll($event)">
              <van-list
                v-model="incomeListLoading"
                :finished="listLoadFinished"
                @load="onLoad"
              >

                <div class="coins-list">
                  <van-cell-group>
                    <div class="van-cell coins-list-cell" v-for="(item, index) in list" :key="index">
                      <div class="van-cell__title">
                        <span class="title">{{ item.operate }}</span>
                        <div class="van-cell__label">{{ item.createTime }}</div>
                      </div>
                      <div class="van-cell__value2">
                        <div style="width: 1px;height: 1px;"> </div>
                        <div class="van-cell-user2">
                          <span> 邀请{{ item.userCount }}人</span>
                        </div>
                      </div>
                      <span class="icon_invalid" v-show="item.expire === 1"></span>
                    </div>
                  </van-cell-group>
                </div>
              </van-list>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getCoinListByRecommend } from '@api/activity'

export default {
  name: 'newInviteFriends',
  data () {
    return {
      showBar: false,
      mobile: '',
      cryptoPhone: '',
      totalRows: 0,

      pageSize: 10,
      pageNum: 0,
      incomeListLoading: false,
      listLoadFinished: false,
      list: []
    }
  },

  created () {

    this.showBar = this.$route.query.showBar

    this.mobile = this.$route.query.mobile

    this.cryptoPhone = this.mobile.replace(/(\d{3})\d{4}(\d{4})/,"$1****$2");

    this.onLoad()
  },

  mounted () {


  },

  methods: {

    // 获取页面滚动距离
    handleScroll (e) {
      let el = e.target

      //判断是否到达div容器底部
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        // this.$toastMsg('滚动')
        //调用后台接口
        this.onLoad()
      }
    },

    onClickLeft () {
      // 返回上个页面
      this.$bridge.callHandler('back', response => {
        console.log('response:', response)
      })
    },

    // 获取历史记录
    onLoad () {
      this.pageNum++
      this.incomeListLoading = true
      getCoinListByRecommend({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        mobile: this.mobile
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            this.listLoadFinished = true
          } else {
            this.list = this.list.concat(res.data.data.rows)
          }
          this.totalRows = res.data.data.totalRows
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="less">

.newInviteFriends {
  min-height: 100%;
  background-color: #FFFFFF;

  .van-nav-bar {
    background-color: #FD3043;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-icon {
    color: #FFFFFF !important;;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-nav-bar__title {
    color: #FFFFFF !important;
  }
}

.title-div{
  background-color: #FD3043;
  height: 55px;
  font-size: 16px;
  color: #FFFFFF;
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
  align-items: center;
}
.huodong-div {
  background: #FFFFFF;
  //height: 100%;
  width: 100%;
}

.hist-list {
  background-color: #FFFFFF;
  padding-bottom: 30px;

  .hist-div {
    padding: 12px;
    border-radius: 8px;
    opacity: 1;
  }
}

.hist-content {
  //min-height: 216px;
  width: 100%;
}


.list-content {
  width: 100%;
  text-align: left;
  //max-height: 400px;
  overflow: auto;
  white-space: nowrap;

}

.van-cell {
  padding: 8px;
  background: #F7F8FA;
  border-radius: 10px;
  margin-bottom: 10px;
  display: flex;
  height: 60px;
  justify-content: space-between;

  .title {
    font-size: 14px !important;
  }

  .van-cell__label {
    font-size: 13px !important;
  }

  .van-cell__value2 {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;

    .van-cell-user2{
      display: flex;
      font-size: 13px;
      line-height: 16px;
      justify-content: right;
      color: #FFB111;
      .van-icon {
        font-size: 16px;
      }
    }
  }
}

.van-cell:not(:last-child)::after {
  display: inline;
}

</style>
